import { Divider, Stack } from '@/src/packages/components';
import { useProductForm } from '@/src/packages/components/contexts/product-form.context';
import { useProductContext } from '@/src/packages/components/pages/Product/ProductContext';
import { ProductSizeSelection } from '@/src/packages/components/pages/Product/ProductControls/ProductOptions/ProductSizeSelector';
import { ProductVariantSelector } from '@/src/packages/components/pages/Product/ProductControls/ProductOptions/ProductVariantSelector';

export const ProductOptions = () => {
  const { productVariant, options } = useProductContext();

  const { handleSelectOption, selectedOptions } = useProductForm();

  return (
    <Stack spaceY={4} divider={<Divider borderColor="muted" />}>
      {productVariant.product.variants.length > 1 && <ProductVariantSelector />}

      {options.map((option) => {
        return (
          <ProductSizeSelection
            key={option.id}
            option={option}
            options={options}
            selectedOptions={selectedOptions}
            handleSelectOption={handleSelectOption}
            skus={productVariant.skus}
          />
        );
      })}
    </Stack>
  );
};
